// Seções que abrem e fecham (0.67.2, texto 07): o que a pessoa deixou aberto ou fechado fica guardado NESTE aparelho.
// Usado pelo componente único de seção recolhível (components/Recolhivel.tsx, com a prop "chave").
// Fica em memória (leitura síncrona: a tela já abre certa) e é gravado no AsyncStorage a cada mudança.
import { useSyncExternalStore } from 'react';
import AsyncStorage from '@react-native-async-storage/async-storage';

const CHAVE = 'mp_recolher';
let estado: Record<string, boolean> = {};   // chave -> aberto
const ouvintes = new Set<() => void>();
const avisar = () => ouvintes.forEach(f => f());

AsyncStorage.getItem(CHAVE).then(s => {
  if (!s) return;
  try { estado = { ...JSON.parse(s), ...estado }; avisar(); } catch { /* guardado inválido: ignora */ }
}, () => {});

export function setAberto(chave: string, aberto: boolean) {
  estado = { ...estado, [chave]: aberto };
  avisar();
  AsyncStorage.setItem(CHAVE, JSON.stringify(estado)).catch(() => {});
}
/** Aberto ou fechado (o guardado; sem nada guardado, o inicial). */
const assinar = (cb: () => void) => { ouvintes.add(cb); return () => { ouvintes.delete(cb); }; };
export function useAberto(chave: string | undefined, inicial: boolean): boolean {
  const v = useSyncExternalStore(assinar, () => (chave ? estado[chave] : undefined));
  return v ?? inicial;
}
/** Texto 27 (A2): todo o guardado (para listas com muitas chaves, ex.: os subtítulos de uma caixa). */
export function useRecolherTudo(): Record<string, boolean> {
  return useSyncExternalStore(assinar, () => estado);
}
